import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BusinessService } from '@app/business/business.service';
import { TranslateService } from '@ngx-translate/core';
import { SessionStorageService } from '@app/core';
import { MatTableDataSource } from '@angular/material/table';
import { InfoService } from '@app/core/info/info.service';

@Component({
  selector: 'cloud-cloud-web-identification-history-details',
  templateUrl: './cloud-web-identification-history-details.component.html',
  styleUrls: ['./cloud-web-identification-history-details.component.scss']
})
export class CloudWebIdentificationHistoryDetailsComponent implements OnInit {
  @Output() close: EventEmitter<any> = new EventEmitter();
  wait: boolean;
  rowData: any;
  displayedColumnsDocumentList = ['status', 'filename', 'sentTimestamp', 'deadlineTimestamp', 'signedTimestamp', 'actions'];
  companyCmrId: any;
  signsessionId: any;
  idResult: any;
  websessionId: any;
  downloadingFiles: Set<string> = new Set();
  tableDocumentList = new MatTableDataSource();
  noResponse: boolean;
  asJson: boolean;

  constructor(
    private sessionStorageService: SessionStorageService,
    private businessService: BusinessService,
    private translateService: TranslateService,
    public info: InfoService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.rowData = data
  }

  ngOnInit(): void {
    // this.companyCmrId = 12345;
     this.companyCmrId = this.sessionStorageService.getItem("businessAccountId");
    if (this.rowData) {
      this.wait = false
    } else {
      this.wait = true;
    }
    this.getDocumentList()
  }

  closeDialog() {
    this.close.emit(null);
  }
  getName() {
    return this.translateService.currentLang === 'bg' ? this.rowData.name.bg : this.rowData.name.en;
  }

  getDocumentList() {
    this.noResponse = false;
    this.idResult = this.rowData.id
    this.businessService.getDocumentList(this.companyCmrId, this.idResult)
      .subscribe((response: any) => {
        if (!response) {
          this.info.error('signingTexts.signingError');
          return;
        }
        else if (response.status == 200) {
          const documentList = response?.body?.data?.map((doc: any) => ({
            ...doc,
            asJson: doc.fileName === 'eID.pdf'
          })) || [];
          this.tableDocumentList = new MatTableDataSource(documentList);
          this.noResponse = true;
        } else {
          this.info.error(response.message);
        }
      })
  }

  onDownloadDocument(doc?: any): void {
    if (doc && this.rowData?.status === 'EXPIRED' && doc.signSessionId) {
      this.downloadExpiredFile(doc);
    } else if (doc && doc.signSessionId) {
      this.downloadSpecificFile(doc);
    } else if (doc && doc.webSessionId) {
      this.downloadEIDDocument(doc);
    }
  }

  private downloadExpiredFile(doc: any): void {
    this.idResult = doc.resultId;
    this.signsessionId = doc.signSessionId;
    if (this.downloadingFiles.has(doc.fileName)) {
      return;
    }
    this.downloadingFiles.add(doc.fileName);

    this.businessService.getDownloadUEIEXPIRED(this.companyCmrId, this.idResult, this.signsessionId)
      .subscribe({
        next: (response: any) => {
          try {
            const responseData = response?.body?.data;
            const base64SingleDoc = responseData?.eIDDocAsBase64;

            if (base64SingleDoc) {
              this.downloadBase64File(base64SingleDoc, doc.fileName);
            } else if (Array.isArray(responseData?.signDocuments)) {
              const matched = responseData.signDocuments.find((d: any) =>
                d?.filename?.trim().toLowerCase() === doc.fileName?.trim().toLowerCase()
              );

              if (matched && matched.contentAsBase64) {
                this.downloadBase64File(matched.contentAsBase64, matched.filename);
              } else {
                this.info.warning(this.translateService.instant('businessTexts.documentIsNotAvailable'));
              }
            }
          } catch (error) {
            console.error(error);
          } finally {
            this.downloadingFiles.delete(doc.fileName);
          }
        },
        error: (error) => {
          this.downloadingFiles.delete(doc.fileName);
        }
      });
  }

  private downloadSpecificFile(doc: any): void {
    this.idResult = doc.resultId;
    this.signsessionId = doc.signSessionId;
    if (this.downloadingFiles.has(doc.fileName)) {
      return;
    }
    this.downloadingFiles.add(doc.fileName);
    this.businessService.getDownloadUEISIGN(this.companyCmrId, this.idResult, this.signsessionId)
      .subscribe({
        next: (response: any) => {
          try {
            const responseData = response?.body?.data;
            const base64SingleDoc = responseData?.eIDDocAsBase64;

            if (base64SingleDoc) {
              this.downloadBase64File(base64SingleDoc, doc.fileName);
            } else if (Array.isArray(responseData?.signDocuments)) {
              const matched = responseData.signDocuments.find((d: any) =>
                d?.filename?.trim().toLowerCase() === doc.fileName?.trim().toLowerCase()
              );

              if (matched && matched.contentAsBase64) {
                this.downloadBase64File(matched.contentAsBase64, matched.filename);
              } else {
                this.info.warning(this.translateService.instant('businessTexts.documentIsNotAvailable'))
              }
            }
          } catch (error) {
            console.error(error);
          } finally {
            this.downloadingFiles.delete(doc.fileName);
          }
        },
        error: (error) => {        
          this.downloadingFiles.delete(doc.fileName);
        }
      });
  }

  downloadIdentificationFile(doc: any): void {
    this.idResult = doc.resultId
    this.signsessionId = doc.signSessionId

    if (this.downloadingFiles.has(doc.fileName)) {
      return;
    }

    this.downloadingFiles.add(doc.fileName);

    this.businessService.getDownloadIdentification(this.companyCmrId, this.idResult, this.signsessionId)
      .subscribe({
        next: (response: any) => {
          try {
            const data = response?.body?.data;
            if (!data) {
              this.info.warning(this.translateService.instant('businessTexts.noDataDownload'))
              return;
            }

            const jsonStr = JSON.stringify(data, null, 2);
            const blob = new Blob([jsonStr], { type: 'application/json' });

            const downloadLink = document.createElement('a');
            downloadLink.href = URL.createObjectURL(blob);
            const baseName = doc.fileName.replace(/\.[^/.]+$/, '');
            downloadLink.download = `${baseName}.json`;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
          } catch (error) {           
             this.info.warning(this.translateService.instant('businessTexts.errorOccurredJSONfile'))
          } finally {
            this.downloadingFiles.delete(doc.fileName);
          }
        },
        error: (error) => {
          this.downloadingFiles.delete(doc.fileName);
        }
      });
  }

  private downloadEIDDocument(doc: any) {
    const filename = 'eIDDocument.pdf';
    if (this.downloadingFiles.has(filename)) {
      return;
    }
    this.downloadingFiles.add(filename);
    this.idResult = doc.resultId
    this.websessionId = doc.webSessionId;
    this.businessService.getDownloadUEICREATE(this.companyCmrId, this.idResult, this.websessionId)
      .subscribe({
        next: (response: any) => {
          try {
            const responseData = response.body.data;
            if (responseData && responseData.eIDDocAsBase64) {
              this.downloadBase64File(responseData.eIDDocAsBase64, filename);
            } else {
              console.error('eIDDocAsBase64 content not found in response');
            }
          } catch (error) {
            console.error(error);
          } finally {
            this.downloadingFiles.delete(filename);
          }
        },
        error: (error) => {
          console.error(error);
          this.downloadingFiles.delete(filename);
        }
      });
  }

  private downloadBase64File(contentAsBase64: string, filename: string): void {
    try {
      const byteCharacters = atob(contentAsBase64);
      const byteNumbers = new Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setTimeout(() => {
        URL.revokeObjectURL(url);
      }, 100);

    } catch (error) {
      console.error(error);
    }
  }

  isDownloading(filename: string): boolean {
    return this.downloadingFiles.has(filename);
  }

  isDownloadingEIDDoc(): boolean {
    return this.downloadingFiles.has('eIDDocument.pdf');
  }

  trackByFilename(index: number, doc: any): string {
    return doc.filename;
  }

}
